/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, TableFooter, ButtonGroup } from "@mui/material";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { postSync, getSaleType } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

const SaleType = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState(undefined);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN LOẠI HÌNH BÁN"));
    getSaleType().then((res) => {
      if (res.code !== 200) return;
      try {
        setData(res.data);
      } catch {}
    });
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICall title="Cập nhật dữ liệu từ ERP" api={() => postSync({ object: "saletype" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Code")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày tạo")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                return (
                  <TableRow key={row.id}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.created_at && moment(row.created_at).format("DD/MM/YYYY")} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.name} </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default SaleType;
